import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import './Config.scss';
import { Input } from 'reactstrap';

import { setConfig } from '../../actions';

import {  
  Dropdown,
  validateNumber,
  HeaderSection,
  Card,
} from '../../helpers';
import commonConstant from '../../common/_commonConstant';

class Config extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'carBuildingFreeParkingCondition': null,
      'carBuildingFreeParkingMinutes': '',
      'carOverNightActive' : 'ENABLE',
      'carOvernightTimeStart' : null,
      'carOvernightTimeEnd' : null,
      'carOvernightFee' : '',
      'carOvernightChargeType' : null,
      'motorcycleBuildingFreeParkingCondition': null,
      'motorcycleBuildingFreeParkingMinutes': '',
      'motorcycleOverNightActive' : 'ENABLE',
      'motorcycleOvernightTimeStart' : null,
      'motorcycleOvernightTimeEnd' : null,
      'motorcycleOvernightFee' : '',
      'motorcycleOvernightChargeType' : null,
    };
    this.carBuildingFreeParkingCondition = createRef();
    this.carOvernightChargeType = createRef();
    this.carOvernightTimeStart = createRef();
    this.carOvernightTimeEnd = createRef();
    this.motorcycleBuildingFreeParkingCondition = createRef();
    this.motorcycleOvernightChargeType = createRef();
    this.motorcycleOvernightTimeStart = createRef();
    this.motorcycleOvernightTimeEnd = createRef();
  }

  componentDidMount() {
    this.dataFillInput();
  }

  dataFillInput = () => {
    const { config } = this.props;
    
    
    if (config != null) {
      const car = config.buildingConfigCar;
      const motorcycle = config.buildingConfigMotorcycle;
      this.setState({
        'carBuildingFreeParkingCondition': car.buildingFreeParkingCondition !== null ? commonConstant.buildingFreeParkingCondition.filter((item) => item.value === car.buildingFreeParkingCondition)[0] : null,
        'carBuildingFreeParkingMinutes': car.buildingFreeParkingMinutes !== null ? car.buildingFreeParkingMinutes.toString() : '',
        'carOverNightActive' : car.overNightActive,
        'carOvernightTimeStart' : car.overnightTimeStart !== null ? commonConstant.parkingTimePeriodStart.filter((item) => item.value === car.overnightTimeStart)[0] : null,
        'carOvernightTimeEnd' : car.overnightTimeEnd !== null ? commonConstant.parkingTimePeriodStart.filter((item) => item.value === car.overnightTimeEnd)[0] : null,
        'carOvernightFee' : car.overnightFee !== null ? car.overnightFee.toString() : '',
        'carOvernightChargeType' : car.overnightChargeType !== null ? commonConstant.overnightChargeType.filter((item) => item.value === car.overnightChargeType)[0] : null,
        'motorcycleBuildingFreeParkingCondition': motorcycle.buildingFreeParkingCondition !== null ? commonConstant.buildingFreeParkingCondition.filter((item) => item.value === motorcycle.buildingFreeParkingCondition)[0] : null,
        'motorcycleBuildingFreeParkingMinutes': motorcycle.buildingFreeParkingMinutes !== null ? motorcycle.buildingFreeParkingMinutes.toString() : '',
        'motorcycleOverNightActive' : motorcycle.overNightActive,
        'motorcycleOvernightTimeStart' : motorcycle.overnightTimeStart !== null ? commonConstant.parkingTimePeriodStart.filter((item) => item.value === motorcycle.overnightTimeStart)[0] : null,
        'motorcycleOvernightTimeEnd' : motorcycle.overnightTimeEnd !== null ? commonConstant.parkingTimePeriodStart.filter((item) => item.value === motorcycle.overnightTimeEnd)[0] : null,
        'motorcycleOvernightFee' : motorcycle.overnightFee !== null ? motorcycle.overnightFee.toString() : '',
        'motorcycleOvernightChargeType' : motorcycle.overnightChargeType !== null ? commonConstant.overnightChargeType.filter((item) => item.value === motorcycle.overnightChargeType)[0] : null,
      });
    }
  }

    handleIsCanSave = (vehicleType) => {
      if (this.state[`${vehicleType}BuildingFreeParkingCondition`] !== null && this.state[`${vehicleType}BuildingFreeParkingMinutes`] !== ''){
        if (this.state[`${vehicleType}OverNightActive`] === 'ENABLE'){ 
          if (this.state[`${vehicleType}OvernightChargeType`] !== null && this.state[`${vehicleType}OvernightChargeType`].value === 'TIME_PERIOD') {
            if (this.state[`${vehicleType}OvernightTimeStart`] != null && this.state[`${vehicleType}OvernightTimeEnd`] != null && this.state[`${vehicleType}OvernightFee`] !== '') {
              return true;
            } else {
              return false;
            }
          } else if (this.state[`${vehicleType}OvernightChargeType`] !== null && this.state[`${vehicleType}OvernightChargeType`].value === '24_HOURS') {
            if (this.state[`${vehicleType}OvernightFee`] !== '') {
              return true;
            } else {
              return false;
            }
          } else {
            return false;
          }
        } else {
          return true;
        }
      } else {
        return false;
      }
    }
 
    handleDispatchData = () => {
      const { carBuildingFreeParkingCondition, carBuildingFreeParkingMinutes, carOverNightActive, 
        carOvernightTimeStart, carOvernightTimeEnd, carOvernightFee, carOvernightChargeType,
        motorcycleBuildingFreeParkingCondition, motorcycleBuildingFreeParkingMinutes, motorcycleOverNightActive, 
        motorcycleOvernightTimeStart, motorcycleOvernightTimeEnd, motorcycleOvernightFee, motorcycleOvernightChargeType,
      } = this.state;
      const isCanSave = [];

      isCanSave.push(this.handleIsCanSave('car'));
      isCanSave.push(this.handleIsCanSave('motorcycle'));       

      this.props.dispatch(setConfig({ 
        'buildingConfigCar': {
          'buildingFreeParkingMinutes': carBuildingFreeParkingMinutes !== '' ? parseInt(carBuildingFreeParkingMinutes) : null,
          'buildingFreeParkingCondition': carBuildingFreeParkingCondition !== null ? carBuildingFreeParkingCondition.value : null,
          'overNightActive': carOverNightActive,
          'overnightTimeStart': carOvernightTimeStart !== null ? carOvernightTimeStart.value : null,
          'overnightTimeEnd': carOvernightTimeEnd !== null ? carOvernightTimeEnd.value : null,
          'overnightFee': carOvernightFee !== '' ? parseInt(carOvernightFee) : null,
          'overnightChargeType': carOvernightChargeType !== null ? carOvernightChargeType.value : null,
        },
        'buildingConfigMotorcycle': {
          'buildingFreeParkingMinutes': motorcycleBuildingFreeParkingMinutes !== '' ? parseInt(motorcycleBuildingFreeParkingMinutes) : null,
          'buildingFreeParkingCondition': motorcycleBuildingFreeParkingCondition !== null ? motorcycleBuildingFreeParkingCondition.value : null,
          'overNightActive': motorcycleOverNightActive,
          'overnightTimeStart': motorcycleOvernightTimeStart !== null ? motorcycleOvernightTimeStart.value : null,
          'overnightTimeEnd': motorcycleOvernightTimeEnd !== null ? motorcycleOvernightTimeEnd.value : null,
          'overnightFee': motorcycleOvernightFee !== '' ? parseInt(motorcycleOvernightFee) : null,
          'overnightChargeType': motorcycleOvernightChargeType !== null ? motorcycleOvernightChargeType.value : null,
        },
        'isCanSave': !isCanSave.includes(false),
      }));
    }

    handleEvent = (key, value) => {      
      if (key === 'carBuildingFreeParkingCondition') {
        this.carBuildingFreeParkingCondition.current.handleShowItem();
      } else if (key === 'carOvernightChargeType') {
        if (value.value === '24_HOURS'){ 
          this.setState({              
            'carOvernightTimeStart': null,
            'carOvernightTimeEnd': null,
          });
        }
        this.carOvernightChargeType.current.handleShowItem();
      } else if (key === 'motorcycleOvernightChargeType') {
        if (value.value === '24_HOURS'){ 
          this.setState({              
            'motorcycleOvernightTimeStart': null,
            'motorcycleOvernightTimeEnd': null,
          });
        }
        this.motorcycleOvernightChargeType.current.handleShowItem();
      } else if (key === 'motorcycleBuildingFreeParkingCondition') {
        this.motorcycleBuildingFreeParkingCondition.current.handleShowItem();
      } else if (key === 'carOvernightTimeStart') {
        this.carOvernightTimeStart.current.handleShowItem();
      } else if (key === 'carOvernightTimeEnd') {
        this.carOvernightTimeEnd.current.handleShowItem();
      } else if (key === 'motorcycleOvernightTimeStart') {
        this.motorcycleOvernightTimeStart.current.handleShowItem();
      } else if (key === 'motorcycleOvernightTimeEnd') {
        this.motorcycleOvernightTimeEnd.current.handleShowItem();
      }

      this.setState({ [key]: value }, () => this.handleDispatchData());
    }

    handleConfigSection = (vehicleType) => (
      <Card>
        <HeaderSection title="Building free parking" />
        <div className="building-free-parking-container">
          <div className="building-free-parking-condition-container">
            <div className="building-free-parking-condition-label">Building free parking condition</div>
            <div className="building-free-parking-condition-dropdown">
              <Dropdown template="b" placeholder="Choose building free parking condition " value={this.state[`${vehicleType}BuildingFreeParkingCondition`] ? this.state[`${vehicleType}BuildingFreeParkingCondition`].label : null} ref={this[`${vehicleType}BuildingFreeParkingCondition`]} >
                {
                  commonConstant.buildingFreeParkingCondition.map((ele, index) => (
                    <div
                      key={index}
                      className={`item${this.state[`${vehicleType}BuildingFreeParkingCondition`] && this.state[`${vehicleType}BuildingFreeParkingCondition`].value === ele.value ? ' active' : ''}`}
                      onClick={() => this.handleEvent(`${vehicleType}BuildingFreeParkingCondition`, ele)}
                    >{ele.label}</div>
                  ))
                }
              </Dropdown>
            </div>           
          </div>
          <div className="building-free-parking-minutes-container">
            <div className="building-free-parking-minutes-label">Building free parking minutes</div>
            <div className="building-free-parking-minutes-input">
              <Input
                id={`${vehicleType}-building-free-parking-minutes-input`}
                className={'template-d'}
                placeholder="Input building free parking minutes"
                value={this.state[`${vehicleType}BuildingFreeParkingMinutes`]}
                onChange={(event) => {
                  const value = event.target.value;
                  if (validateNumber(value)) {
                    this.handleEvent(`${vehicleType}BuildingFreeParkingMinutes`, value);
                  }
                }}
              />
            </div>
          </div>         
        </div>
        <HeaderSection title="Overnight fee config" />
        <div className="overnight-fee-config-container">
          <div className="first-row-container">
            <div className="overnight-status-container">
              <div className="overnight-status-label">Overnight active</div>
              <div className="status-button-container">
                <div className={`status-button ${this.state[`${vehicleType}OverNightActive`] === 'ENABLE' ? 'active' : ''}`} onClick={() => this.handleEvent(`${vehicleType}OverNightActive`, 'ENABLE')}>Enable</div>
                <div className={`status-button ${this.state[`${vehicleType}OverNightActive`] === 'DISABLE' ? 'active' : ''}`} onClick={() => this.handleEvent(`${vehicleType}OverNightActive`, 'DISABLE')}>Disable</div>
              </div>
            </div>
            <div className="overnight-charge-type-container">
              <div className="overnight-charge-type-label">Overnight charge type</div>
              <div className="overnight-charge-type-dropdown">
                <Dropdown template="b" placeholder="Choose overnight charge type" value={this.state[`${vehicleType}OvernightChargeType`] ? this.state[`${vehicleType}OvernightChargeType`].label : null} ref={this[`${vehicleType}OvernightChargeType`]} >
                  {
                    commonConstant.overnightChargeType.map((ele, index) => (
                      <div
                        key={index}
                        className={`item${this.state[`${vehicleType}OvernightChargeType`] && this.state[`${vehicleType}OvernightChargeType`].value === ele.value ? ' active' : ''}`}
                        onClick={() => this.handleEvent(`${vehicleType}OvernightChargeType`, ele)}
                      >{ele.label}</div>
                    ))
                  }
                </Dropdown>
              </div>           
            </div>
          </div>
          <div className="second-row">
            {
              this.state[`${vehicleType}OvernightChargeType`] && this.state[`${vehicleType}OvernightChargeType`].value === 'TIME_PERIOD' ? <div className="overnight-time-container">
                <div className="overnight-time-start-container">
                  <div className="overnight-time-start-label">Overnight time start</div>
                  <div className="overnight-time-start-dropdown">
                    <Dropdown template="b" placeholder="Choose Overnight time start" value={this.state[`${vehicleType}OvernightTimeStart`] ? this.state[`${vehicleType}OvernightTimeStart`].label : null} ref={this[`${vehicleType}OvernightTimeStart`]} >
                      <div className="overnight-time-start-dropdown-option">
                        {
                          commonConstant.parkingTimePeriodStart.map((ele, index) => (
                            <div
                              key={index}
                              className={`item${this.state[`${vehicleType}OvernightTimeStart`] && this.state[`${vehicleType}OvernightTimeStart`].value === ele.value ? ' active' : ''}`}
                              onClick={() => this.handleEvent(`${vehicleType}OvernightTimeStart`, ele)}
                            >{ele.label}</div>
                          ))
                        }
                      </div>
                    </Dropdown>
                  </div>
                </div>
                <div className="overnight-time-end-container">
                  <div className="overnight-time-end-label">Overnight time end</div>
                  <div className="overnight-time-end-dropdown">
                    <Dropdown template="b" placeholder="Choose overnight time end" value={this.state[`${vehicleType}OvernightTimeEnd`] ? this.state[`${vehicleType}OvernightTimeEnd`].label : null} ref={this[`${vehicleType}OvernightTimeEnd`]} >
                      <div className="overnight-time-end-dropdown-option">
                        {
                          commonConstant.parkingTimePeriodStart.map((ele, index) => (
                            <div
                              key={index}
                              className={`item${this.state[`${vehicleType}OvernightTimeEnd`] && this.state[`${vehicleType}OvernightTimeEnd`].value === ele.value ? ' active' : ''}`}
                              onClick={() => this.handleEvent(`${vehicleType}OvernightTimeEnd`, ele)}
                            >{ele.label}</div>
                          ))
                        }
                      </div>
                    </Dropdown>
                  </div>           
                </div>           
                
              </div> : null
            }
            <div className="overnight-fee-container">
              <div className="overnight-fee-label">Overnight fee</div>
              <div className="overnight-fee-input">
                <Input
                  id={`${vehicleType}-overnight-fee-input`}
                  className={'template-d'}
                  placeholder="Input overnight fee"
                  value={this.state[`${vehicleType}OvernightFee`]}
                  onChange={(event) => {
                    const value = event.target.value;
                    if (validateNumber(value)) {
                      this.handleEvent(`${vehicleType}OvernightFee`, value);
                    }
                  }}
                />
              </div>
            </div>
          </div>
        </div>
     
      </Card>
    )

    render() {
      return (
        <div className="Config">
          <HeaderSection title="Car config" isHeader={true} />
          {this.handleConfigSection('car')}      
          <HeaderSection title="Motorcycle config" isHeader={true} />
          {this.handleConfigSection('motorcycle')} 
        </div>
      );
    }
}

const mapStateToProps = ({ config }) => ({
  'config': config.data,
});

export default connect(mapStateToProps)(Config);

Config.propTypes = {
  'dispatch' : PropTypes.func,
  'config' : PropTypes.shape({
    'buildingConfigCar' : PropTypes.shape({
      'buildingFreeParkingMinutes' : PropTypes.number,
      'buildingFreeParkingCondition' : PropTypes.string,
      'overNightActive': PropTypes.string,
      'overnightTimeStart': PropTypes.string,
      'overnightTimeEnd': PropTypes.string,
      'overnightFee' : PropTypes.number,
      'overnightChargeType' : PropTypes.string,
    }),
    'buildingConfigMotorcycle' : PropTypes.shape({
      'buildingFreeParkingMinutes' : PropTypes.number,
      'buildingFreeParkingCondition' : PropTypes.string,
      'overNightActive': PropTypes.string,
      'overnightTimeStart': PropTypes.string,
      'overnightTimeEnd': PropTypes.string,
      'overnightFee' : PropTypes.number,
      'overnightChargeType' : PropTypes.string,
    }),
  }),
};
